/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "../utils/Api";
import SyncLoader from "react-spinners/SyncLoader";

const Students = () => {
  const [studentDetails, setStudentDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate(); // Initialize useNavigate

  const fetchStudentDetails = async () => {
    setLoading(true);
    const token = localStorage.getItem("authToken");
    const fd = new FormData();
    fd.append("programType", "getChildrenDetails");
    fd.append("authToken", token);
    fd.append("playerId", localStorage.getItem("player_id"));

     for (let pair of fd.entries()) {
      console.log(pair[0] + ": " + pair[1]);
    }

    try {
      const response = await api.post("parentApp/studentCurl2", fd);
      console.log("stu", response)

      if (response.data?.success) {
        const students = response.data.data;
        if (Array.isArray(students)) {
          setStudentDetails(students);
        } else {
          // console.error("Unexpected data format, expected array:", students);
          setStudentDetails([]);
        }
      } else {
        console.error("Failed to fetch student details:", response.data);
      }
    } catch (error) {
      console.error("Error fetching student details:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStudentDetails();
  }, []);

  const handleStudentClick = async (
    enrollId,
    branchId,
    studentId,
    studentName
  ) => {
    setLoading(true);
    const token = localStorage.getItem("authToken");
    const fd = new FormData();
    fd.append("programType", "storePlayerId");
    fd.append("authToken", token);
    // fd.append("playerId", localStorage.getItem("player_id"));
    fd.append("studentId", localStorage.getItem("studentId"));

    fd.append("playerId", 1234455);


    // for (let pair of fd.entries()) {
    //   console.log(pair[0] + ": " + pair[1]);
    // }

    try {
      const response = await api.post("parentApp/studentCurl2", fd);
      // console.log("stst", response)

      if (response.data?.success) {
        const students = response.data.data;
        localStorage.setItem("enrollId", enrollId); // Store enrollId in localStorage
        localStorage.setItem("branchId", branchId); // Store enrollId in localStorage
        localStorage.setItem("studentId", studentId); // Store enrollId in localStorage
        localStorage.setItem("studentName", studentName); // Store enrollId in localStorage

        if (Array.isArray(students)) {
          setStudentDetails(students);
        } else {
          // console.error("Unexpected data format, expected array:", students);
          setStudentDetails([]);
        }
        navigate(`/home`); // Navigate to "/homes"
      } else {
        localStorage.setItem("enrollId", enrollId); // Store enrollId in localStorage
        localStorage.setItem("branchId", branchId); // Store enrollId in localStorage
        localStorage.setItem("studentId", studentId); // Store enrollId in localStorage
        localStorage.setItem("studentName", studentName); // Store enrollId in localStorage

        navigate(`/home`); // Navigate to "/homes"
        console.error("Failed to fetch student details:", response.data);
      }
    } catch (error) {
      console.error("Error fetching student details:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4">
      <h2 className="mb-4">Student Details</h2>
      {loading && (
        <div className="text-center my-4">
          <SyncLoader
            color="orange"
            loading={loading}
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 9999,
            }}
            size={8}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        </div>
      )}

      <div className="row">
        {!loading &&
          studentDetails.map((student) => (
            <div
              className="col-md-12 col-lg-12 mb-3"
              key={student.studentId}
              onClick={() =>
                handleStudentClick(
                  student.enrollId,
                  student.branchId,
                  student.studentId,
                  student.studentName
                )
              } // Store enrollId on click
              style={{ cursor: "pointer" }} // Change cursor to indicate it's clickable
            >
              <div className="card mt-3 user-data-card d-flex flex-row align-items-center p-3 shadow-sm">
                <img
                  // src={
                  //   student.photo && student.photo !== "default.png"
                  //     ? `${student.photo}`
                  //     : "https://cdn.vectorstock.com/i/1000v/66/13/default-avatar-profile-icon-social-media-user-vector-49816613.jpg"
                  // }
                  src="assets/img/bg-img/default.png"
                  alt={student.studentName}
                  className="rounded-circle"
                  style={{ width: "80px", height: "80px", marginRight: "15px" }}
                />
                <div>
                  <div className="card-body">
                    <h5 className="mb-1 ">{student.studentName}</h5>
                    <p className="mb-1">
                      <strong className="form-label">
                        Roll No: {student.roll}
                      </strong>
                    </p>
                    <p className="mb-1">
                      <strong className="form-label">
                        Branch: {student.branchName}
                      </strong>
                    </p>
                    <p className="mb-0">
                      <strong className="form-label">
                        Class: {student.className}
                      </strong>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default Students;
